<template>
  <v-flex :lg2="!showFilters" md3 sm4 xs6 class="mb-4">
    <v-card
      class="mx-auto"
      color="background"
      outlined
      hover
      max-width="230px"
      height="100%"
      style="border: 0"
    >
      <v-row justify="start" align="stretch" no-gutters style="height: 100%">
        <v-hover>
          <template v-slot:default="{ hover }">
            <v-col cols="12" lg="12" xs="12">
              <router-link
                :to="{
                  name: 'TemplateOrdersProductInfo',
                  params: { id: product.prod_no, product: product },
                }"
              >
                <v-row justify="start" align="start" no-gutters>
                  <v-col cols="12" lg="12" xs="12">
                    <ProductImage :product="product"></ProductImage>
                  </v-col>
                  <v-col cols="12" lg="12" xs="12">
                    <Tags :product="product"></Tags>
                    <ProductName :product="product"></ProductName>
                  </v-col>
                </v-row>
              </router-link>
            </v-col>
          </template>
        </v-hover>

        <v-col
          cols="12"
          lg="12"
          xs="12"
          style="display: flex; align-items: flex-end"
        >
          <!-- <GridInput :product="product" :isBasketItem="isEditing" :isTemplateItem="true"></GridInput> -->
          <v-btn
            v-if="!isEditing"
            color="blue darken-2"
            outlined
            block
            class="px-0"
            :loading="loadingSubmit"
            @click="addTemplateItem(product)"
            style="height: 40px"
            >Add</v-btn
          >
          <v-btn
            v-else
            color="error"
            outlined
            block
            class="px-0"
            :loading="loadingSubmit"
            @click="removeTemplateItem(product)"
            style="height: 40px"
            >Delete</v-btn
          >
        </v-col>
      </v-row>
    </v-card>
  </v-flex>
</template> 

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";

import ProductImage from "@/components/product/ProductImage.vue";
import ProductName from "@/components/product/ProductName.vue";

import Tags from "@/components/product/Tags.vue";

export default {
  components: {
    ProductImage,
    ProductName,
    Tags,
  },

  props: {
    isEditing: Boolean,
    showFilters: Boolean,
    product: {},
  },

  data() {
    return {
      loadingSubmit: false,
    };
  },

  computed: {
    isProdGrid() {
      if (this.$store.getters.retrieveProductGrid) {
        return true;
      } else {
        return false;
      }
    },
    showCode() {
      return this.$store.getters.retrieveProductCode;
    },
    showCountry() {
      return this.$store.getters.retrieveProductCountry;
    },
    productName() {
      if (this.$store.getters.retrieveCashDescriptionForAccounts) {
        if (this.product.CsAndCncProductDescription) {
          return this.product.CsAndCncProductDescription;
        } else {
          return this.product.prod_desc;
        }
      } else if (
        (this.$store.getters.retrieveIsCncCustomer &&
          this.product.CsAndCncProductDescription) ||
        (this.$store.getters.retrieveIsCashCustomer &&
          this.product.CsAndCncProductDescription)
      ) {
        return this.product.CsAndCncProductDescription;
      } else {
        return this.product.prod_desc;
      }
    },
    productVarSize() {
      if (
        (this.$store.getters.retrieveIsCncCustomer &&
          this.product.CsAndCncProductDescription) ||
        (this.$store.getters.retrieveIsCashCustomer &&
          this.product.CsAndCncProductDescription)
      ) {
        return null;
      } else {
        let returnString = "";

        if (this.product.variety) {
          returnString += this.product.variety;
        }

        if (this.product.size) {
          if (returnString != "") {
            returnString += " - ";
          }
          returnString += this.product.size;
        }

        return returnString;
      }
    },
  },

  methods: {
    ...mapActions(["getTemplates", "setSnackbar", "deleteTrolly"]),

    async addTemplateItem(item) {
      this.loadingSubmit = true;

      console.log("-- Remove Console Logging");
      console.log(this.$store.getters.retrieveCurrentTemplate);
      console.log(this.$store.getters.retrieveCurrentTemplate.id);

      let stringPayload = JSON.stringify({
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        userId: this.$store.getters.retrieveUser.userNum,
        trollyId: this.$store.getters.retrieveCurrentTemplate.id,
        prodNo: item.prod_no,
        // qtyType: item.qty_type,
        // qty: item.qty,
        br: 0,
        template: 1,
      });

      const params = new URLSearchParams();
      params.append("params", stringPayload);

      let response = await axios.post("put-trolly-item", params);

      if (response.data.success) {
        this.setSnackbar({ text: "Item added to Template" });
        this.getTemplates();
      } else {
        this.setSnackbar({
          color: "error",
          text: "Error adding item to Template",
        });
      }

      this.loadingSubmit = false;
    },

    async removeTemplateItem(item) {
      this.loadingSubmit = true;

      console.log("-- Remove Console Logging");
      console.log(this.$store.getters.retrieveCurrentTemplate);
      console.log(this.$store.getters.retrieveCurrentTemplate.id);

      let stringPayload = JSON.stringify({
        sessionKey: this.$store.getters.retrieveUser.sessionKey,
        userId: this.$store.getters.retrieveUser.userNum,
        trollyId: this.$store.getters.retrieveCurrentTemplate.id,
        trollyItemId: item.id,
        // prodNo: item.prod_no,
        // qtyType: item.qty_type,
        br: 0,
        template: 1,
      });

      const params = new URLSearchParams();
      params.append("params", stringPayload);

      let response = await axios.post("del-trolly-item", params);

      if (response.data.success) {
        this.setSnackbar({ text: "Item removed from Template" });
        this.getTemplates();
      } else {
        this.setSnackbar({
          color: "error",
          text: "Error removing item from Template",
        });
      }

      this.loadingSubmit = false;
      return;
    },
  },
};
</script>

<style lang="css" scoped>
* {
  word-break: break-word;
}

/* @media (min-width: 1264px) and (max-width: 1904px) { */
@media (min-width: 1264px) {
  .flex.lg2 {
    flex-basis: 20%;
    flex-grow: 0;
    max-width: 20%;
  }
}

.v-card__title {
  font-size: 14px;
  font-weight: bold;
}

.v-card__subtitle {
  padding: 4px 1em;
}

@media (min-width: 1600px) {
  .col-md-3 {
    flex: 0 0 20%;
    max-width: 20%;
  }
}

@media (max-width: 600px) {
  .rowImage {
    margin: 0 auto;
  }
}

.v-card__actions {
  background-color: rgba(0, 0, 0, 0.04);
}

.transparentBG {
  background-color: transparent;
}
</style>